




































































































































































import { Component, Prop , Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwButton } from '@libs-uuif/shared/sw-button';
import { SwModal ,  SwModalFooter , SwModalBody } from '@libs-uuif/shared/sw-modal';
import { SwIcon } from '@sonicwall/unified-ui-framework/src/shared/sw-icon';

@Component({
  components: {
    SwButton,
    SwModal,
    SwModalFooter,
    SwModalBody,
    SwIcon,
  },
})

export default class FileUpload extends SwExtendedVue {

  @Prop({ required: true })
  display: boolean;

  @Prop({ required: true })
  heading: boolean;

  @Prop({ required: true })
  buttonName: boolean;

  @Prop({ required: false })
  errorMessage: string = '';

  errMsg : string = '';

  dragErrMsg : string = '';

  errorFlag :boolean = true;

  fileRead = new FileReader();

  bulkData :any = [];

  returnedData :any = [];

  fileLoaded : boolean = false;

  fileexist: boolean = false;

  fileName:string = '';

  browseFileName : string = '';

  display2 : boolean = this.display;
  created() {
    console.warn('created');
    this.errMsg = this.errorMessage;
    this.dragErrMsg = this.errorMessage;
  }

  @Watch('display')
  onDisplayChange(value : any) {
    this.errorFlag = false;
    this.fileexist = false;
    this.fileLoaded = false;
    this.display2 = value;
  }

  clickChecked(event:any) {
    if (event.srcElement.className.indexOf('sw-modal--regular') > -1) {
      this.$emit('close-modal', false);
    }
  }

  escapeListener(event:any) {
    if (event.code === 'Escape') {
      this.$emit('close-modal', false);
    }
  }

  uploadFile() {
    this.fileexist = false;
    const fileInput : HTMLElement = document.getElementById('fileInput')!;
    this.errorFlag = false;
    fileInput.click();
  }

  loadText(event :any) {
    this.errorFlag = false;
    const file = event.target.files[0];
    console.warn(event);
    if (file) {
      if (file.name.length > 20) {
        const tempName = file.name;
        const ext = '...csv';
        this.browseFileName = tempName.substring(0, 13) + ext;
      }else {
        this.browseFileName = file.name;
      }
      if (file.name.split('.')[1] === 'csv') {
        this.dragErrMsg = '';
        this.errMsg = '';
        const fileRead = new FileReader();
        fileRead.readAsText(file);
        fileRead.onload = (e : any) => {
          const fileContents = e.srcElement.result;
          const fileTextLines = fileContents.split(/\r\n|\n/);
          this.returnedData = fileTextLines;
          this.fileLoaded = true;
        };
      } else {
        this.onDisplayChange(true);
        this.fileexist = false;
        this.errMsg = (this.$t('products.invalidFile')
        .toString());
      }
    } else {
      this.onDisplayChange(true);
    }
  }

  downloadCsv() {
    console.warn('clicked');
    let csvContent = 'data:text/csv;charset=utf-8,';
    // tslint:disable-next-line:max-line-length
    csvContent += 'SERIALNUMBER,AUTHCODE,FRIENDLYNAME,HAPRIMARYSERIALNUMBER,TRADEINSERIALNUMBER,ZTSUPPORT,TENANTNAME,DATACENTER,GMSSERIALNUMBER,STORAGEORSATAPARENT,CASAPP,CASSUBDOMAIN,AWSTOKEN,COUNTRY\r\n18B16*******,ABCDEFGH,ABCDEFGH,,,0  ro 1,12cscma,,,,,,,\r\n';
    const data = encodeURI(csvContent);
    const link = document.createElement('a');
    console.warn(link);
    document.body.appendChild(link);
    link.setAttribute('href', data);
    link.setAttribute('download', 'sample.csv');
    link.click();
    document.body.removeChild(link);
  }

  onDrop(event: any) {
    this.fileexist = true;
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    if (file) {
      if (file.name.split('.')[1] === 'csv') {
        this.errMsg = '';
        this.dragErrMsg = '';
        if (file.name.length > 20) {
          const tempName = file.name;
          const ext = '...csv';
          this.fileName = tempName.substring(0, 13) + ext;
        }else {
          this.fileName = file.name;
        }
        const fileRead = new FileReader();
        fileRead.readAsText(file);
        fileRead.onload = (e : any) => {
          const fileContents = e.srcElement.result;
          const fileTextLines = fileContents.split(/\r\n|\n/);
          this.returnedData = fileTextLines;
        };
      } else {
        this.onDisplayChange(true);
        this.fileexist = false;
        this.dragErrMsg = (this.$t('products.invalidFile')
        .toString());
      }
    } else {
      this.onDisplayChange(true);
    }
  }

  addProduct() {
    console.warn('added product');
    console.warn(this.returnedData);
    if (this.returnedData.length > 0 && this.errMsg === '') {
      this.$emit('returned-data', this.returnedData);
      this.$emit('close-modal', false);
    }
  }

}
